import ReactDOM from "react-dom/client";
import reportWebVitals from "./reportWebVitals";
import { CssBaseline, StyledEngineProvider, ThemeProvider } from "@mui/material";
import theme from "./styles/theme";
import { BrowserRouter } from "react-router-dom";
import RTL from "./components/rtl/RTL";
import Router from "./router";
import { QueryClient, QueryClientProvider, QueryCache } from "react-query";
import "./utils/convertDigits";
import "./styles/font.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
  queryCache: new QueryCache(),
});

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <RTL>
    <ThemeProvider theme={theme}>
      <StyledEngineProvider injectFirst>
        <CssBaseline />
        <QueryClientProvider client={queryClient}>
          <BrowserRouter>
            <Router />
          </BrowserRouter>
        </QueryClientProvider>
      </StyledEngineProvider>
    </ThemeProvider>
  </RTL>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
